import { getStore } from "../components/common/StoreCommon";
import { getUserNameById } from "../store/hub/users";

export default class UserService {

  getUserName(id) {
   return getUserNameById(getStore().getState())(id);
  }

}
